<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">1. The Golden Apple</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">2. Preparing for War</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">3. The Trojan Horse</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">4. The Odyssey of the Vines</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">5. The Fairest One</span></p>
<p class="TOC1"><span href="#/Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?73f74949